<template>
  <div>
    <sortPrice @sortType="sortType"></sortPrice>
    <van-list 
    @load="getList"
      :finished="finished"
      v-model="loading"
      finished-text="没有更多了"
    >
    <productionList :productlist="datas"></productionList>
    </van-list>
  </div>
</template>
<script>
import { goodsList } from '@/api/goods'
import productionList from '@/components/productList'
import { sortPrice } from './components'

import { List } from 'vant'

export default {
  components: {
    productionList,
    sortPrice,
    [List.name]: List
  },
  data () {
    return {
      datas: [],
      page: 0,
      loading: false,
      finished: false,
    }
  },
  methods: {
    async getList (sortType = {}) {
      this.page++
      //判断是几级分类
      const routerCateType = this.$route.query.cate_type
      const cate_type = {
        ['1']: 'first_cat_id',
        ['2']: 'second_cat_id',
        ['3']: 'third_cat_id'
      }
      this.loading = true
      const result = await goodsList({
        //筛选
        ...sortType,
        page: this.page,
        size: 6,
        keywords: this.$route.query.keyword || null,
        [cate_type[routerCateType]]: this.$route.query.cat_id || null,
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
      this.loading = false
      if (result.data.data.goodsList.data.length !== 0) {
        this.datas = this.datas.concat(result.data.data.goodsList.data)
      } else {
        this.finished = true
      }
    },
    sortType (value) {
      this.datas = []
      this.page = 0
      this.finished = false
      this.getList(value)
    }
  }
}
</script>
